import useBaseMessangeSuccess from './useBaseMessageSuccess';
import useMessage from './useMessage';

function useMessageSuccess() {
  return useBaseMessangeSuccess({ hook: useMessage });
}

export default useMessageSuccess;
